var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "p-l-10 p-r-10 p-t-5 p-b-5" },
    [
      _c(
        "table",
        {
          staticClass: "table table_beauty call-log-sub-table-record condensed"
        },
        [
          _c(
            "thead",
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.parsedCallRecords, function(value, record) {
                return _c("tr", { key: record }, [
                  _c("td", [_vm._v(_vm._s(record))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "TruncatedTextCopy",
                        { attrs: { "copy-text": value } },
                        [
                          _vm._v(
                            "\n            " + _vm._s(value) + "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Values")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }